export default "__VITE_ASSET__Cj1vz_K7__"